(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ss-film"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ss-film')) {
    class SsFilm extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.button = this.querySelector('.ss-film__toggle');
        this.loaded = false;
        this.userPaused = false;
        this.inView = false;

        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const saveData = navigator.connection && navigator.connection.saveData === true;
        this.autoplay = !reduce && !saveData;

        this.button.addEventListener('click', () => this.toggle());
        this.video.addEventListener('play', () => this.sync());
        this.video.addEventListener('pause', () => this.sync());

        this.observer = new IntersectionObserver((entries) => {
          for (const entry of entries) {
            this.inView = entry.isIntersecting;
            if (this.inView) {
              this.attachPoster();
              if (this.autoplay && !this.userPaused) this.play();
            } else if (!this.video.paused) {
              this.video.pause();
            }
          }
        }, { rootMargin: '300px 0px' });
        this.observer.observe(this);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      attachPoster() {
        if (this.video.poster) return;
        this.video.poster = this.video.dataset.poster;
        this.button.hidden = false;
        this.sync();
      }

      load() {
        if (this.loaded) return;
        this.loaded = true;
        this.video.querySelectorAll('source[data-src]').forEach((source) => {
          source.src = source.dataset.src;
        });
        this.video.load();
      }

      play() {
        this.load();
        const attempt = this.video.play();
        if (attempt && attempt.catch) attempt.catch(() => this.sync());
      }

      toggle() {
        if (this.video.paused) {
          this.userPaused = false;
          this.play();
        } else {
          this.userPaused = true;
          this.video.pause();
        }
      }

      sync() {
        const playing = !this.video.paused;
        this.button.classList.toggle('is-playing', playing);
        this.button.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
      }
    }
    customElements.define('ss-film', SsFilm);
  }
  } catch(e) { console.error(e); }
})();

})();
